import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import Tooltip from "@mui/material/Tooltip";

const LabelAndDots = ({ label, tooltip, required }) => {
  const containerRef = useRef(null);
  const labelWrapperRef = useRef(null);
  const [dotCount, setDotCount] = useState(1);
  const dotSetString = " · ";

  const updateDots = () => {
    if (!containerRef.current || !labelWrapperRef.current) return;
    const containerWidth = containerRef.current.offsetWidth;
    const labelRenderedWidth = labelWrapperRef.current.offsetWidth;
    const marginLeft = 8;
    const availableWidth = containerWidth - labelRenderedWidth - marginLeft;
    if (availableWidth < 0) {
      setDotCount(1);
      return;
    }
    const dotWidth = 6;
    let count = Math.floor(availableWidth / dotWidth);
    if (count < 1) count = 1;
    setDotCount(count);
  };

  useEffect(() => {
    updateDots();
    window.addEventListener("resize", updateDots);
    return () => window.removeEventListener("resize", updateDots);
  }, []);

  useLayoutEffect(() => {
    if (containerRef.current) {
      const observer = new ResizeObserver(updateDots);
      observer.observe(containerRef.current);
      return () => observer.disconnect();
    }
  }, []);

  return (
    <div
      ref={containerRef}
      className="flex items-center w-full overflow-hidden"
    >
      <Tooltip title={tooltip || label}>
        <div
          ref={labelWrapperRef}
          className="inline-block whitespace-nowrap hover:underline"
        >
          {label}
        </div>
      </Tooltip>
      {required && <span className="text-red-500 ml-1">*</span>}
      <span
        style={{ marginLeft: 8 }}
        className="flex-none text-gray-300 whitespace-nowrap"
      >
        {dotSetString.repeat(dotCount)}
      </span>
    </div>
  );
};

export default LabelAndDots;
